module.exports = __webpack_public_path__ + "static/img/sctcm_login_bg.1dce823.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sctcm_login_bg.jpg
// module id = ZNsq
// module chunks = 1